import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import portalTheme from "../../../themes/portalTheme";

import cx from 'classnames';
import s from '../FormElement.css';


const PortalSelectField = ({
  className, description, disabled, id, errorText, fullWidth,
  label, name, onChange, options, required, value, onBlur,
}) => {
  return (
    <div className={cx(s.component, className, {[`${s.disabled}`]: disabled})}>
      <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
        <SelectField
          className={s.input}
          disabled={disabled}
          errorText={errorText}
          errorStyle={{color:'#B2120B'}}
          id={id}
          title={name}
          iconStyle={{fill:'#222222'}}
          floatingLabelText={label}
          floatingLabelStyle={{color:'#222222'}}
          selectedMenuItemStyle={{color:'#277B7C'}}
          fullWidth={fullWidth}
          name={name}
          onChange={(event, index, payload) => { if (onChange) onChange(event, payload) }}
          required={required}
          value={value}
          onBlur={onBlur}
        >

          {options.map((option, index) => (
            <MenuItem key={`${id}__${index}`}
              id={`${id}__${index}`}
              title={option}
              primaryText={option}
              value={option} />
          ))}
        </SelectField>
      </MuiThemeProvider>

      {description &&
        <label className={cx(s.description, {[`${s.moveDown}`]: errorText})}>{description}</label>
      }
    </div>
  );
};

PortalSelectField.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  errorText: PropTypes.node,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  required: PropTypes.bool,
  value: PropTypes.any,
  onBlur: PropTypes.func,
};

export default PortalSelectField;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalSelectField/PortalSelectField.js